import { overrideFeatureFlagsWithQueryParams } from '@scouts/helpers'

import config from './config'

export const featureFlags = overrideFeatureFlagsWithQueryParams(config.isProduction, {
    featureBookkeepingQuotes: import.meta.env.REACT_APP_FEATURE_BOOKKEEPING_QUOTES === 'true',
    featureDevelopmentKeyboardShortcuts: import.meta.env.REACT_APP_FEATURE_DEVELOPMENT_KEYBOARD_SHORTCUTS === 'true',
    featureStandaloneBookkeepingExporting:
        import.meta.env.REACT_APP_FEATURE_STANDALONE_BOOKKEEPING_EXPORTING === 'true',
    featureTaxReturnKoinly: import.meta.env.REACT_APP_FEATURE_TAX_RETURN_KOINLY === 'true',
    featureBookkeepingDeductibility: import.meta.env.REACT_APP_FEATURE_BOOKKEEPING_DEDUCTIBILITY === 'true',
    featureBankingRecurringTransactions: import.meta.env.REACT_APP_FEATURE_BANKING_RECURRING_TRANSACTIONS === 'true',
    featureCompanyTaxReturns: import.meta.env.REACT_APP_FEATURE_COMPANY_TAX_RETURNS === 'true',
    featureBookkeepingRecentRecords: import.meta.env.REACT_APP_FEATURE_BOOKKEEPING_RECENT_RECORDS === 'true',
    featureEnableCanaryIsland: import.meta.env.REACT_APP_FEATURE_ENABLE_CANARY_ISLAND === 'true',
    featureQuarterlyApproveScreenNRCView:
        import.meta.env.REACT_APP_FEATURE_QUARTERLY_APPROVE_SCREEN_NRC_VIEW === 'true',
    featureBookkeepingInvoiceV2: import.meta.env.REACT_APP_FEATURE_BOOKKEEPING_INVOICE_V2 === 'true',
    featureWorkActivities: import.meta.env.REACT_APP_FEATURE_WORK_ACTIVITIES === 'true',
})
